import React from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IMdBentity, IMdStoreDetail } from "../StoreTypes";
import { useStoreModel } from "../storeModel";

const columns: ColumnsType<IMdStoreDetail> = [
    {
        align: 'center',
        title: '序号',
        width: 60,
        render: (v, r, i) => i + 1
    },
    {
        align: "center",
        title: '分支编码',
        width: 100,
        dataIndex: 'branch',
    },
    {
        align: "center",
        title: '门店编码',
        width: 150,
        dataIndex: 'code',
    },
    {
        align: "center",
        title: '门店名称',
        width: 150,
        dataIndex: 'name',
    },
    {
        align: "center",
        title: '门店类型',
        width: 120,
        dataIndex: 'categoryName',
    },
    {
        align: "center",
        title: '从属机构',
        width: 150,
        dataIndex: 'orgName',
    },
    {
        align: "center",
        title: '关联实体',
        width: 150,
        dataIndex: 'details',
        render: (value, record, index) => {
            return value && value.map((item: IMdBentity) => <span className="my-tag">{item.bentityName}</span>)
        }
    },
    {
        align: "center",
        title: '负责人',
        width: 120,
        dataIndex: 'contact',
    },
    {
        align: "center",
        title: '联系电话',
        width: 150,
        dataIndex: 'phone',
    },
    {
        align: "center",
        title: '公司地址',
        width: 120,
        dataIndex: 'address',
    },
    {
        align: "center",
        title: '备注',
        width: 120,
        dataIndex: 'note',
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        width: 120,
        render: (v) => v === 0 ? "启用" : "禁用"
    },

];

export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
    } = useStoreModel();


    return (
        <Table
            style={{ cursor: "pointer" }}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdStoreDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
        // onRow={record => {
        //     return {
        //         onClick: event => {
        //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
        //                 setSelectedRowKeys([]);
        //             } else {
        //                 setSelectedRowKeys([record.key]);
        //             }
        //         },
        //     };
        // }}
        />
    )
}
